module.exports = __webpack_public_path__ + "templates/login-needed.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/login-needed.html
// module id = ulzl
// module chunks = 1